import { render, staticRenderFns } from "./PPThumbnail.vue?vue&type=template&id=1534fb02&scoped=true&"
import script from "./PPThumbnail.vue?vue&type=script&lang=js&"
export * from "./PPThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./PPThumbnail.vue?vue&type=style&index=0&id=1534fb02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534fb02",
  null
  
)

export default component.exports